<template>
  <Dialog
    v-model:visible="isVisible"
    modal
    :pt="{
      mask: {
        class: 'backdrop-blur-sm',
      },
    }"
  >
    <template #container="{ closeCallback }">
      <BaseDialogFrame
        :header="header"
        closeable
        header-class="text-[--color-base-text] text-2xl font-bold text-center justify-center"
        class="max-w-[570px] p-6"
        @close="closeCallback"
      >
        <template #body>
          <div class="flex flex-col items-center text-center">
            <p class="text-small-normal mb-6 text-[--color-neutral-neutral] ">
              {{ message }}
            </p>
            <Button
              v-if="showUpgrade"
              :bold="false"
              icon-align="right"
              icon-class="size-[14px]"
              icon="arrow-right"
              label-class="font-normal"
              label="Upgrade"
              class="btn-orange"
              :pt-options="{ mergeProps: true }"
              :pt="{
                root: {
                  class: [
                    'transition duration-150 group flex justify-center !rounded-[8px] opacity-100',
                    {
                      '!px-[20px] !py-[8px]': true,
                    }
                  ],
                }
              }"
              @click="handleUpgrade"
            >
              <div class="flex flex-row-reverse items-center gap-[12px]">
                <Icon name="arrow-right" class="size-4" />
                <span class="text-regular-medium whitespace-nowrap">Upgrade</span>
              </div>
            </Button>
          </div>
        </template>
      </BaseDialogFrame>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import { useRouter } from 'vue-router';

import Icon from '@/common/components/atoms/Icon';
import BaseDialogFrame from '@/common/components/molecules/BaseDialogFrame';
import { mixPanelEvents } from '@/common/constants';
import { track } from '@/helpers/analytics/mixpanel';
import { capitalizeFirstLetter } from '@/helpers/strings';



const isVisible = defineModel<boolean>('visible', {
  default: false,
});

const props = withDefaults(defineProps<{
  plan?: string | null;
  showUpgrade?: boolean;
  upgradeUrl?: string;
  header?: string;
  message?: string;
  source?: string;
  trackingSource?: string;
}>(), {
  plan: null,
  showUpgrade: true,
  upgradeUrl: '/plans',
  header: 'Unlock More Keyword Searches',
  message: 'Upgrade your plan to keep searching keywords and unlock full access instantly.',
  source: 'Quota Keyword Tool',
  trackingSource: undefined,
});

const router = useRouter();

function handleUpgrade() {
  const plan = props.plan ? capitalizeFirstLetter(props.plan) : 'Free';

  track(mixPanelEvents.CLICKED_UPGRADE, {
    'Source': props.trackingSource ?? `${plan} ${props.source}`,
    'Current Plan': plan,
    'Erank Version': 3,
  });
  router.push(props.upgradeUrl);
}
</script>


<style scoped>
.btn-orange {
  @apply !bg-[--color-brand-tangerine] !border-[--color-brand-tangerine] [&>div]:text-[--color-neutral-white];
}
</style>
